// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestTags-cls1_3Kf","cls2":"ResearchInterestTags-cls2_tvC ResearchInterestTags-cls1_3Kf"};